import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ spacing, palette: { greyColor } }: Theme) =>
  createStyles({
    placeholder: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      width: '100%',
      '& .image': {
        maxWidth: 50,
        position: 'relative',
        top: -2,
        marginRight: spacing(3),
      },
      '& .title': {
        color: greyColor.main,
        flexGrow: 1,
      },
      '& .buttons': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 'auto',
      },
    },
  });
